(function () {
    function initAceiiHighlightViewer(section) {
      if (!section || section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      var controls = Array.prototype.slice.call(section.querySelectorAll('.aceii-highlight-control'));
      var mediaItems = Array.prototype.slice.call(section.querySelectorAll('.aceii-highlight-media__item'));

      var nav = section.querySelector('.aceii-highlight-nav');
      var prevButton = section.querySelector('[data-highlight-prev]');
      var nextButton = section.querySelector('[data-highlight-next]');
      var closeButton = section.querySelector('[data-highlight-close]');

      var mobileShell = section.querySelector('[data-mobile-shell]');
      var mobileImage = section.querySelector('[data-mobile-image]');
      var mobileVideo = section.querySelector('[data-mobile-video]');
      var mobileCaption = section.querySelector('[data-mobile-caption]');
      var mobileCounter = section.querySelector('[data-mobile-counter]');
      var mobilePrev = section.querySelector('[data-mobile-prev]');
      var mobileNext = section.querySelector('[data-mobile-next]');
      var mobileClose = section.querySelector('[data-mobile-close]');

      var activeIndex = Number(section.getAttribute('data-default-index') || 0);
      var previousIndex = activeIndex;
      var hasNavigation = false;
      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerMoved = false;
      var isSectionActive = false;
      var videoCache = {};
      var mobileLoadToken = 0;

      var slides = controls.map(function (control, index) {
        var copy = control.querySelector('.aceii-highlight-copy');
        var figure = section.querySelector('[data-highlight-media="' + index + '"]');
        var image = figure ? figure.querySelector('img') : null;
        var video = figure ? figure.querySelector('video') : null;

        return {
          copy: copy ? copy.innerHTML.trim() : '',
          type: video ? 'video' : 'image',
          source: video ? figure.dataset.videoSrc || getVideoSource(video) : image ? image.getAttribute('src') : '',
          mobileSource: figure ? figure.dataset.mobileSrc || '' : '',
          mobileVideoSource: figure ? figure.dataset.mobileVideoSrc || '' : '',
          poster: figure ? figure.dataset.poster || '' : '',
          mobilePoster: figure ? figure.dataset.mobilePoster || '' : '',
          alt: image ? image.getAttribute('alt') : ''
        };
      });

      function isMobile() {
        return window.matchMedia('(max-width: 760px)').matches;
      }

      function pad2(number) {
        return String(number).padStart(2, '0');
      }

      function getVideoSource(video) {
        if (!video) return '';

        var source = video.querySelector('source');

        return video.currentSrc
          || video.getAttribute('src')
          || video.dataset.src
          || (source ? source.getAttribute('src') || source.dataset.src : '')
          || '';
      }

      function getResponsivePoster(figure) {
        if (!figure) return '';

        return isMobile()
          ? figure.dataset.mobilePoster || figure.dataset.poster || ''
          : figure.dataset.poster || '';
      }

      function syncVideoPoster(video) {
        if (!video) return;

        var poster = getResponsivePoster(video.closest('[data-highlight-media]'));

        if (poster && video.getAttribute('poster') !== poster) {
          video.setAttribute('poster', poster);
        }
      }

      function loadVideo(video, preload) {
        if (!video) return;

        var didAttachSource = false;

        syncVideoPoster(video);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = preload || 'metadata';

        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
          didAttachSource = true;
        }

        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
          if (source.dataset.src && !source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            didAttachSource = true;
          }
        });

        if (didAttachSource || video.readyState === 0) {
          video.load();
        }
      }

      function preloadVideoSource(src, preload) {
        if (!src || videoCache[src]) return;

        var video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = preload || 'metadata';
        video.src = src;
        video.load();

        videoCache[src] = video;
      }

      function preloadVideoAt(index, preload) {
        var item = mediaItems[index];
        var slide = slides[index];
        var video = item ? item.querySelector('video') : null;

        if (video && !isMobile()) {
          loadVideo(video, preload || 'metadata');
        }

        if (slide && slide.type === 'video') {
          var source = isMobile()
            ? slide.mobileVideoSource || slide.source
            : slide.source;

          preloadVideoSource(source, preload || 'metadata');
        }
      }

      function preloadNearbyVideos(index) {
        preloadVideoAt(index, 'metadata');

        if (slides.length > 1) {
          preloadVideoAt((index + 1) % slides.length, 'metadata');
        }
      }

      function setupNearViewportPreload() {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              isSectionActive = entry.isIntersecting;

              if (entry.isIntersecting) {
                preloadNearbyVideos(activeIndex);
                playActiveDesktopVideo();
                updateMobileShell(false);
              } else {
                pauseDesktopVideos();
                pauseMobileVideo();
              }
            });
          }, {
            root: null,
            rootMargin: '300px 0px',
            threshold: 0.01
          });

          observer.observe(section);
        } else {
          isSectionActive = true;
          window.setTimeout(function () {
            preloadNearbyVideos(activeIndex);
            playActiveDesktopVideo();
            updateMobileShell(false);
          }, 600);
        }
      }

      function pauseDesktopVideos() {
        mediaItems.forEach(function (item) {
          var video = item.querySelector('video');

          if (!video) return;

          video.pause();
        });
      }

      function playActiveDesktopVideo() {
        if (isMobile()) return;

        mediaItems.forEach(function (item, index) {
          var video = item.querySelector('video');

          if (!video) return;

          if (index === activeIndex && isSectionActive && !document.hidden) {
            loadVideo(video, 'auto');

            var playPromise = video.play();

            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();

            try {
              video.currentTime = 0;
            } catch (error) {}
          }
        });
      }

      function measureLabel(control) {
        var label = control.querySelector('.aceii-highlight-control__label');
        if (!label) return { width: 180, height: 76 };

        var rect = label.getBoundingClientRect();

        return {
          width: Math.ceil(rect.width + 1),
          height: Math.ceil(rect.height || 76)
        };
      }

      function measureContent(control) {
        var content = control.querySelector('.aceii-highlight-control__content-inner');
        if (!content) return measureLabel(control);

        var originalDisplay = content.style.display;
        content.style.display = 'inline-block';

        var rect = content.getBoundingClientRect();
        content.style.display = originalDisplay;

        return {
          width: Math.ceil(rect.width + 1),
          height: Math.ceil(rect.height || 76)
        };
      }

      function sizeDesktopControls() {
        if (isMobile()) return;

        controls.forEach(function (control, index) {
          var size = index === activeIndex ? measureContent(control) : measureLabel(control);
          control.style.width = size.width + 'px';
          control.style.height = size.height + 'px';
        });
      }

      function updateDesktopControls() {
        controls.forEach(function (control, index) {
          var isActive = index === activeIndex;
          control.classList.toggle('is-expanded', isActive);
          control.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        if (nav) {
          nav.classList.toggle('is-visible', hasNavigation);
        }

        if (prevButton) {
          prevButton.classList.toggle('is-disabled', activeIndex <= 0);
        }

        if (nextButton) {
          nextButton.classList.toggle('is-disabled', activeIndex >= controls.length - 1);
        }

        if (closeButton) {
          closeButton.classList.toggle('is-disabled', activeIndex === 0 && !hasNavigation);
        }

        sizeDesktopControls();
      }

      function updateDesktopMedia(force) {
        if (isMobile()) return;

        if (!force && activeIndex === previousIndex) return;

        if (force) {
          mediaItems.forEach(function (item) {
            item.classList.remove('is-active');
            item.classList.remove('is-setup-enter');
          });
        }

        var oldItem = mediaItems[previousIndex];
        var nextItem = mediaItems[activeIndex];

        if (oldItem) {
          oldItem.classList.remove('is-active');
        }

        if (nextItem) {
          nextItem.classList.remove('is-active');
          nextItem.classList.add('is-setup-enter');
          nextItem.offsetWidth;
          nextItem.classList.remove('is-setup-enter');
          nextItem.classList.add('is-active');
        }

        previousIndex = activeIndex;
        playActiveDesktopVideo();
      }

      function syncMobileArrowPosition() {
        if (!mobileShell || !mobileCaption) return;

        window.requestAnimationFrame(function () {
          var captionHeight = mobileCaption.offsetHeight || 88;
          var arrowBottom = 24 + Math.max(0, (captionHeight - 64) / 2);
          mobileShell.style.setProperty('--arrow-bottom', arrowBottom + 'px');
        });
      }

      function stopMobileVideo() {
        if (!mobileVideo) return;

        mobileVideo.pause();
        mobileVideo.removeAttribute('src');
        mobileVideo.load();
      }

      function pauseMobileVideo() {
        if (!mobileVideo) return;

        mobileVideo.pause();
      }

      function finishMobileChange(token) {
        if (token !== mobileLoadToken || !mobileShell) return;

        syncMobileArrowPosition();

        window.requestAnimationFrame(function () {
          if (token === mobileLoadToken) {
            mobileShell.classList.remove('is-changing');
          }
        });
      }

      function updateMobileShell(animate) {
        if (!mobileShell || !mobileImage || !mobileVideo || !mobileCaption) return;

        var slide = slides[activeIndex];

        mobileLoadToken += 1;
        var token = mobileLoadToken;

        if (animate) {
          mobileShell.classList.add('is-changing');
        }

        window.setTimeout(function () {
          if (token !== mobileLoadToken) return;

          mobileCaption.innerHTML = slide.copy;

          if (mobileCounter) {
            mobileCounter.textContent = pad2(activeIndex + 1) + ' / ' + pad2(slides.length);
          }

          if (mobilePrev) {
            mobilePrev.classList.toggle('is-hidden', activeIndex === 0);
          }

          if (mobileNext) {
            mobileNext.classList.toggle('is-hidden', activeIndex === slides.length - 1);
          }

          if (!isMobile() || !isSectionActive || document.hidden) {
            stopMobileVideo();
            mobileVideo.style.display = 'none';
            mobileImage.style.display = slide.type === 'image' ? 'block' : 'none';
            mobileImage.removeAttribute('src');
            finishMobileChange(token);
            return;
          }

          if (slide.type === 'video') {
            var mobileVideoSource = slide.mobileVideoSource || slide.source;

            mobileImage.style.display = 'none';
            mobileImage.removeAttribute('src');

            mobileVideo.style.display = 'block';
            mobileVideo.preload = 'auto';
            mobileVideo.poster = slide.mobilePoster || slide.poster || '';
            mobileVideo.src = mobileVideoSource;
            mobileVideo.load();

            preloadVideoSource(mobileVideoSource, 'metadata');

            var ready = false;

            function markVideoReady() {
              if (ready || token !== mobileLoadToken) return;

              ready = true;

              mobileVideo.play().catch(function () {});
              finishMobileChange(token);
            }

            if (mobileVideo.readyState >= 3) {
              markVideoReady();
            } else {
              mobileVideo.addEventListener('canplay', markVideoReady, { once: true });
              mobileVideo.addEventListener('loadeddata', markVideoReady, { once: true });

              window.setTimeout(markVideoReady, 1200);
            }
          } else {
            stopMobileVideo();

            mobileVideo.style.display = 'none';
            mobileImage.style.display = 'block';
            mobileImage.alt = slide.alt || '';

            mobileImage.onload = function () {
              finishMobileChange(token);
            };

            mobileImage.src = slide.mobileSource || slide.source;

            if (mobileImage.complete) {
              finishMobileChange(token);
            }
          }
        }, animate ? 170 : 0);
      }

      function setActive(index, animate) {
        var nextIndex = Math.max(0, Math.min(index, controls.length - 1));

        if (nextIndex === activeIndex && animate) return;

        if (nextIndex > 0) {
          hasNavigation = true;
        }

        activeIndex = nextIndex;

        if (isSectionActive && !document.hidden) {
          preloadNearbyVideos(activeIndex);
        }

        updateDesktopControls();
        updateDesktopMedia(false);
        updateMobileShell(animate);
      }

      controls.forEach(function (control, index) {
        control.addEventListener('click', function () {
          setActive(index, true);
        });

        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setActive(index, true);
          }
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          if (activeIndex > 0) setActive(activeIndex - 1, true);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (activeIndex < controls.length - 1) setActive(activeIndex + 1, true);
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          hasNavigation = false;
          setActive(0, true);
        });
      }

      if (mobilePrev) {
        mobilePrev.addEventListener('click', function () {
          if (activeIndex > 0) setActive(activeIndex - 1, true);
        });
      }

      if (mobileNext) {
        mobileNext.addEventListener('click', function () {
          if (activeIndex < slides.length - 1) setActive(activeIndex + 1, true);
        });
      }

      if (mobileClose) {
        mobileClose.addEventListener('click', function () {
          hasNavigation = false;
          setActive(0, true);
        });
      }

      if (mobileShell) {
        mobileShell.addEventListener('pointerdown', function (event) {
          if (!isMobile()) return;

          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
          pointerMoved = false;
        }, { passive: true });

        mobileShell.addEventListener('pointermove', function (event) {
          if (!isMobile()) return;

          var deltaX = event.clientX - pointerStartX;
          var deltaY = event.clientY - pointerStartY;

          if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
            pointerMoved = true;
          }
        }, { passive: true });

        mobileShell.addEventListener('pointerup', function (event) {
          if (!isMobile() || !pointerMoved) return;

          var deltaX = event.clientX - pointerStartX;

          if (deltaX < -42 && activeIndex < slides.length - 1) {
            setActive(activeIndex + 1, true);
          }

          if (deltaX > 42 && activeIndex > 0) {
            setActive(activeIndex - 1, true);
          }
        }, { passive: true });
      }

      section.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hasNavigation = false;
          setActive(0, true);
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          if (activeIndex > 0) setActive(activeIndex - 1, true);
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          if (activeIndex < controls.length - 1) setActive(activeIndex + 1, true);
        }
      });

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(function () {
          mediaItems.forEach(function (item) {
            syncVideoPoster(item.querySelector('video'));
          });
          sizeDesktopControls();
          syncMobileArrowPosition();
          updateMobileShell(false);
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseDesktopVideos();
          pauseMobileVideo();
          return;
        }

        if (isSectionActive) {
          preloadNearbyVideos(activeIndex);
          playActiveDesktopVideo();
          updateMobileShell(false);
        }
      });

      setupNearViewportPreload();
      updateDesktopControls();
      updateDesktopMedia(true);
      updateMobileShell(false);
    }

    function initAllAceiiHighlightViewers() {
      var sections = document.querySelectorAll('[data-aceii-highlight-viewer]');
      sections.forEach(initAceiiHighlightViewer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllAceiiHighlightViewers);
    } else {
      initAllAceiiHighlightViewers();
    }

    document.addEventListener('shopify:section:load', initAllAceiiHighlightViewers);
  })();
